import React from 'react';
import PropTypes from 'prop-types';
import _sumBy from 'lodash/sumBy';
import _filter from 'lodash/filter';

import s from './SRLBarSections.module.css';

const getWidthSection = (value, total) => (value * 100) / total;

const SRLBarSections = ({ items }) => {
  const total = _sumBy(items, item => parseFloat(item.value));
  const noEmptySections = _filter(items, item => +item.value !== 0);
  return (
    <div className={s.container}>
      <div className={`${s.sections} ${noEmptySections.length >= 2 ? s.multipleSections : ''}`}>
        {noEmptySections.map(item => (
          item.value !== 0 && (
            <div
              key={item.label}
              style={{ width: `${getWidthSection(item.value, total)}%` }}
              className={`${s.section} ${s[item.color]}`}
            >
              {item.value}
            </div>
          )
        ))}
      </div>
      <div className={s.labels}>
        { items.map(item => (
          <div key={item.label} className={s.label}>
            <div className={`${s.labelColor} ${s[item.color]}`} />
            <div className={s.labelText}>
              <b>{item.label}</b> students
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

SRLBarSections.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.required,
    value: PropTypes.string.required,
    color: PropTypes.string,
  })),
};

export default SRLBarSections;
